module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/createnode-0da223dd05d8f4864c7e5abaef152232.svg";